import "../../utils/messages";
import { PC_MESSAGES, GROUP_MESSAGES, CONTROLS_NOT_RETRIEVED, IPERIUSREMOTE_MESSAGE } from "../../utils/messages";
import { ClientMessage } from "../../utils/objects";

export function assignGroupRequests(api) {
    api.getGroups = async function () {
        var response = await api.get('/shgroups/v2', this.buildConfig())
            .then(res => res.data.groups.map(g => {
                //g.pcs = [];
                return g;
            }))
            .catch(e => {
                this.checkError(e, GROUP_MESSAGES.LIST_NOT_RETRIEVED);
                return [];
            });

        return response;
    }
    api.saveNote = async function (note) {
        var config = this.buildConfig();
        var noteString = JSON.stringify(note);
        if (note.id == null) {
            var response = await api.post(
                '/notes',
                noteString,
                config
            ).then(res => {
                if (res.status == 400) return null;
                return res.data;
            }).catch(e => {
                this.checkError(e, PC_MESSAGES.NOTE_NOT_SAVED);
                return null;
            });
        } else {

            var response = await api.put(
                '/notes',
                noteString,
                config
            ).then(res => {
                if (res.status == 400) return null;
                return res.data;
            }).catch(e => {
                this.checkError(e, PC_MESSAGES.NOTE_NOT_SAVED);
                return null;
            });
        }

        return response;
    }
    api.terminateSession = async function (id_remote) {

        var data = { "id_remote": id_remote }

        var customConfig = this.buildConfig();
        customConfig.baseURL = process.env.VUE_APP_BASE_URL_REMOTE; // chiamata alle rest api del server socket di remote

        var response = await api.post(
            '/remote/disconnect',
            data,
            customConfig // Passa la configurazione personalizzata
        ).then(res => {
            if (res.status == 400) return null;
            return res;
        }).catch(e => {
            this.checkError(e, IPERIUSREMOTE_MESSAGE.NOT_TERMINATE);

            return null;
        });

        return response;

    }
    api.deleteComputerFromAddressBook = async function (id_pc, also_one) {

        const url = '/computers/' + id_pc + '?rfg=' + also_one;

        var response = await api.delete(url, this.buildConfig()).then(res => {
            if (res.status == 400) return null;
            return res;
        }).catch(e => {
            this.checkError(e, PC_MESSAGES.REMOVE_FROM_ADDRESSBOOK_ERR);

            return null;
        });

        return response;

    }



    api.getControls = async function () {
        var response = await api.get('/controls', this.buildConfig())
            .then(res => {
                return res.data;
            })
            .catch(e => {
                this.checkError(e, CONTROLS_NOT_RETRIEVED);
                return [];
            });

        return response;
    }
    api.getGroup = async function (idgroup) {
        var response = await api.get('/groupswu/' + idgroup, this.buildConfig())
            .catch(e => {
                this.checkError(e);
                return null;
            });
        response.data.computers = response.data.computers.map(pc => { pc.connected = false; return pc })
        response.data.ids_computers = response.data.computers.map(pc => { return pc.id })
        response.data.ids_users = response.data.users.map(user => { return user.id })
        return response.data;
    }

    api.createGroup = async function (group) {

        var config = this.buildConfig();
        var clientMessage = ClientMessage.success(GROUP_MESSAGES.CREATED);

        var response = await api.post(
            '/shgroups?full=true',
            JSON.stringify(group),
            config
        ).then(res => {
            if (res.status == 400) return null;

            return res.data;
        }).catch(e => {
            clientMessage = this.checkError(e, GROUP_MESSAGES.NOT_CREATED);
            /*  Object.keys(e.data.user.errors).forEach(key => {
                 e.data.user.errors[key].forEach(message => console.log(key + " : " + message))
             }); */
            return null;
        });

        this.emitFunction("sendClientMessage", clientMessage, "groupmethods");

        return response;
    }

    api.editGroup = async function (group) {
        var config = this.buildConfig();
        var groupString = JSON.stringify(group);
        var clientMessage = ClientMessage.success(GROUP_MESSAGES.MODIFIED);
        //config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        var response = await api.put(
            '/groups?full=true',
            groupString,
            config
        ).then(res => {
            if (res.status == 400) return null;
            return res.data;
        }).catch(e => {
            clientMessage = this.checkError(e, GROUP_MESSAGES.NOT_MODIFIED);
            return null;
        });

        this.emitFunction("sendClientMessage", clientMessage, "groupmethods");

        return response;
    }

    api.deleteGroup = async function (groupid) {
        var clientMessage = ClientMessage.success(GROUP_MESSAGES.DELETED);

        var response = await api.delete('/groups/' + groupid, this.buildConfig())
            .then(res => res.status != 400)
            .catch(e => {
                clientMessage = this.checkError(e, GROUP_MESSAGES.NOT_DELETED);
                return false;
            });

        this.emitFunction("sendClientMessage", clientMessage, "groupmethods");

        return response;
    }

    api.updateIperiusRemote4 = async function (id_remote) {

        var data = { "id_remote": id_remote }

        var customConfig = this.buildConfig();
        customConfig.baseURL = process.env.VUE_APP_BASE_URL_REMOTE; // chiamata alle rest api del server socket di remote

        var response = await api.post(
            '/remote/update',
            data,
            customConfig // Passa la configurazione personalizzata
        ).then(res => {
            if (res.status == 400) return null;
            return res;
        }).catch(e => {
            this.checkError(e, IPERIUSREMOTE_MESSAGE.NOT_UPDATE);

            return null;
        });

        return response;
    }

    api.restartIperiusRemote4 = async function (id_remote) {

        var data = { "id_remote": id_remote }

        var customConfig = this.buildConfig();
        customConfig.baseURL = process.env.VUE_APP_BASE_URL_REMOTE; // chiamata alle rest api del server socket di remote       

        var response = await api.post(
            '/remote/restart',
            data,
            customConfig // Passa la configurazione personalizzata
        ).then(res => {
            if (res.status == 400) return null;
            return res;
        }).catch(e => {
            this.checkError(e, IPERIUSREMOTE_MESSAGE.NOT_RESTART);

            return null;
        });

        if (response == null)
            this.createToastFunction(this.translateFunction(IPERIUSREMOTE_MESSAGE.NOT_RESTART), "alert");

        return response;

    }
    api.unistallIperiusRemote4 = async function (id_remote) {

        var data = { "id_remote": id_remote }

        var customConfig = this.buildConfig();
        customConfig.baseURL = process.env.VUE_APP_BASE_URL_REMOTE; // chiamata alle rest api del server socket di remote       

        var response = await api.post(
            '/remote/uninstall',
            data,
            customConfig // Passa la configurazione personalizzata
        ).then(res => {
            if (res.status == 400) return null;
            return res;
        }).catch(e => {
            this.checkError(e, IPERIUSREMOTE_MESSAGE.NOT_UNINSTALL);

            return null;
        });

        if (response == null)
            this.createToastFunction(this.translateFunction(IPERIUSREMOTE_MESSAGE.NOT_RESTART), "alert");

        return response;

    }
    api.closeIperiusRemote4 = async function (id_remote) {

        var data = { "id_remote": id_remote }

        var customConfig = this.buildConfig();
        customConfig.baseURL = process.env.VUE_APP_BASE_URL_REMOTE; // chiamata alle rest api del server socket di remote        

        var response = await api.post(
            '/remote/terminate',
            data,
            customConfig // Passa la configurazione personalizzata
        ).then(res => {
            if (res.status == 400) return null;
            return res;
        }).catch(e => {
            this.checkError(e, IPERIUSREMOTE_MESSAGE.NOT_CLOSE);
            return null;
        });

        return response;

    }

    api.latestIperiusRemote4Version = async function () {

        var data = { "ver": 'x64' }

        var customConfig = this.buildConfig();
        customConfig.baseURL = process.env.VUE_APP_BASE_URL_REMOTE; // chiamata alle rest api del server socket di remote        

        var response = await api.post(
            '/getversion',
            data,
            customConfig // Passa la configurazione personalizzata
        ).then(res => {
            if (res.status == 400) return null;
            return res;
        }).catch(e => {
            this.checkError(e, IPERIUSREMOTE_MESSAGE.NOT_VER);
            return null;
        });

        return response;

    }

    api.getIperiusRemote4ClientStatus = async function (ids_remote) {

        var data = ids_remote;

        var customConfig = this.buildConfig();
        customConfig.baseURL = process.env.VUE_APP_BASE_URL_REMOTE; // chiamata alle rest api del server socket di remote

        var response = await api.put(
            '/remote/isonline',
            data,
            customConfig // Passa la configurazione personalizzata
        ).then(res => {
            if (res.status == 400) return null;
            return res;
        }).catch(e => {
            this.checkError(e, IPERIUSREMOTE_MESSAGE.NOT_STATUS);
            return null;
        });

        return response;

    }
}
